module.exports = __webpack_public_path__ + "static/img/blue-sphere-120.e98f740.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/blue-sphere-120.png
// module id = /Bk7
// module chunks = 1